import React from 'react'
import PropTypes from 'prop-types'
import { Header as PartnerHeader } from '@pcln/partner-config'
import createMarkup from '../../utils/create-markup'
import Cobrand from '../Cobrand'

const Header = ({ headerHTML, partner }) => {
  if (partner) {
    return (
      <div id="exp-hdr">
        <div
          className="fixed"
          id={`${partner.plfCode}-global-header`}
          data-testid={`${partner.plfCode}-global-header`}
        >
          <PartnerHeader baseImageUrl="/shop/search" partner={partner} />
        </div>
      </div>
    )
  }

  return headerHTML.length > 0 ? (
    <div id="exp-hdr" className="experimental-header">
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={createMarkup(headerHTML)}
        className="fixed"
        id="pcln-global-header"
      />
      <Cobrand />
    </div>
  ) : null
}

Header.propTypes = {
  headerHTML: PropTypes.string.isRequired,
  partner: PropTypes.shape({
    plfCode: PropTypes.string,
    globalPartnerCode: PropTypes.string,
    config: PropTypes.object
  })
}

export default Header
